



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import moment from 'moment'

@Component
export default class SuporteTabelaContratos extends Vue {
  @Prop({ default: 'principal' }) base!: string
  baseAtual: string = ''

  regrasDeCalculo: Array<any> = []

  contratosHeaders = [
    { text: 'Contrato', value: 'nomeContrato', sortable: false },
    { text: 'Fonte Pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Prestador', value: 'prestador', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Status', value: 'ativo', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  statusColors: { [key: string]: { text: string; bg: string } } = {
    'Ativo': {
      'text': 'green',
      'bg': 'light-green lighten-4'
    },
    'Inativo': {
      'text': 'red',
      'bg': 'red lighten-4'
    },
    'Pendente': {
      'text': 'orange',
      'bg': 'orange lighten-4'
    }
  }

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get contratosVisaoGestor() {
    return this.baseAtual === 'principal' ? this.getBackofficeContratosStore.contratosGestorBaseRemuneracao : this.getBackofficeContratosStore.contratosGestor
  }

  get loadingContratos() {
    return this.getBackofficeContratosStore.loadingTabelaContratos
  }

  set loadingTable(value: boolean) {
    this.getBackofficeContratosStore.setLoadingTabelaContratos(value)
  }

  get pagination() {
    return this.baseAtual === 'principal' ? this.getBackofficeContratosStore.paginationRemuneracao : this.getBackofficeContratosStore.pagination
  }

  get getPagina() {
    return this.pagination.page
  }

  set getPagina(value: number) {
    this.baseAtual === 'principal' ? this.getBackofficeContratosStore.setPaginaRemuneracao(value) : this.getBackofficeContratosStore.setPagina(value)
  }

  get remuneracaoLength() {
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  viewDetails(item: any) {
    this.getBackofficeContratosStore.setSelectedContratoGestor(item)
    this.$router.push('/suporte/contratos/details')
  }

  async getResults() {
    this.loadingTable = true
    this.baseAtual === 'principal' ? await this.getBackofficeContratosStore.getContratosVisaoGestorBaseRemuneracao(this.pagination) : await this.getBackofficeContratosStore.getContratosVisaoGestor(this.pagination)
    this.loadingTable = false
  }

  @Watch('base')
  onBaseChanged(newBase: string) {
    this.baseAtual = newBase
  }
}
